import React from "react";

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import DonutChart from "@/components/ui/donut";
import * as m from "@/paraglide/messages";

type Props = {};

export default function bentoRebalance({}: Props) {
  return (
    <>
      <Card className="relative col-span-full overflow-hidden lg:col-span-3">
        <CardHeader></CardHeader>
        <CardContent>
          <div className="grid sm:grid-cols-2">
            <div className="relative z-10 flex flex-col justify-between space-y-6 lg:space-y-6">
              <div className="relative flex aspect-square size-12 rounded-full border before:absolute before:-inset-2 before:rounded-full before:border dark:border-white/10 dark:bg-white/5 dark:before:border-white/5 dark:before:bg-white/5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="m-auto size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
              </div>
              <div className=" lg:space-y-2">
                <h2 className="text-lg font-bold text-foreground">
                  {m.major_smart_lizard_feast()}
                </h2>
                <p className="text-muted-foreground">
                  {m.inner_zippy_dingo_hunt()}
                </p>
              </div>
            </div>
            <div className="relative -mb-16 -mr-24 mt-8 h-fit rounded-tl-xl sm:mt-auto">
              <DonutChart />
            </div>
          </div>
        </CardContent>
        <CardFooter></CardFooter>
      </Card>
    </>
  );
}
